var $e0559716da91db81$exports = {};
$e0559716da91db81$exports = {
    "alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


export {$e0559716da91db81$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
